import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { SuperAdminAddConversionForm } from '../../../presentation-components/super-admin/super-admin-add-conversion-form';
import ConversionFactorCustomService from '../../../../shared/services/conversion-factor-custom/conversion-factor-custom-service';
import { IPostConversionFactorCustom } from '../../../../shared/services/conversion-factor-custom/conversion-factor-custom.model';

export const SuperAdminAddConversionFactorsPage = () => {
  const { conversionSourceId } = useParams();
  const navigate = useNavigate();
  //Services
  const conversionFactorCustomService = new ConversionFactorCustomService();
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext);
  //State
  const [newConversion, setNewConversion] = useState<IPostConversionFactorCustom>({
    detailLevelOne: '',
    detailLevelTwo: '',
    detailLevelThree: '',
    measurementUnitId: '',
    greenHouseGasUnitId: '7ec07fb5-371e-4830-9068-ac4f65fd7f4c',
    multiplier: undefined,
    categoryId: '',
    conversionSourceId: conversionSourceId!,
    scope: '1',
    isRenewable: false,
  });
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);

  const submitHandler = (values: IPostConversionFactorCustom) => {
    setIsFormSubmitting(true);
    conversionFactorCustomService.create(values)
      .then((response) => {
        setIsFormSubmitting(false);
        userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
        navigate(`/super-admin/conversion-factors/${conversionSourceId}?tabId=1`);
      })
      .catch((err) => {
        setIsFormSubmitting(false);
        console.log(err);
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
      });
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Add Conversion Factor'
        includeBackButton={true}
        backButtonLink={`/super-admin/conversion-factors/${conversionSourceId}`}
        backButtonText='Back to Conversion Factors'
      />
      {conversionSourceId &&
        <SuperAdminAddConversionForm
          newConversion={newConversion}
          isSubmitting={isFormSubmitting}
          conversionSourceId={conversionSourceId}
          submitHandler={submitHandler}
        />}
    </PageOuterContainer>
  );
}

